<div *ngIf="shouldShow" class="wrapper">
  <nb-card [status]="smsCardType$ | async">
    <nb-card-header> {{ smsWording$ | async }} </nb-card-header>
  </nb-card>

  <nb-card [status]="emailCardType$ | async">
    <nb-card-header> {{ emailWording$ | async }} </nb-card-header>
  </nb-card>
</div>
